import script from "./FilaCruce.vue?vue&type=script&setup=true&lang=ts"
export * from "./FilaCruce.vue?vue&type=script&setup=true&lang=ts"

import "./FilaCruce.vue?vue&type=style&index=0&id=63b95635&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63b95635"]])

export default __exports__